import React, { useState } from 'react';
import './AddPlayerForm.css';
import { createPlayer } from '../services/api';

function AddPlayerForm({ onPlayerAdded, players = [] }) {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!name.trim()) {
      setError('Player name is required');
      return;
    }

    // Check for duplicate name (case-insensitive) on frontend
    const normalizedName = name.trim().toLowerCase();
    const isDuplicate = players.some(p => p.name.toLowerCase() === normalizedName);
    if (isDuplicate) {
      setError(`Player name "${name.trim()}" already exists`);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await createPlayer(name.trim());
      setName('');
      onPlayerAdded();
    } catch (err) {
      // Handle duplicate name error (409 Conflict)
      if (err.message.includes('already exists') || err.message.includes('409')) {
        setError(`Player name "${name.trim()}" already exists`);
      } else {
        setError(err.message || 'Failed to add player');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
    // Clear error when user starts typing
    if (error) {
      setError(null);
    }
  };

  return (
    <form className="add-player-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <input
          type="text"
          className={`form-input ${error ? 'form-input-error' : ''}`}
          placeholder="Enter player name"
          value={name}
          onChange={handleNameChange}
          disabled={loading}
        />
        {error && <div className="form-error">{error}</div>}
      </div>
      <button 
        type="submit" 
        className="btn btn-primary"
        disabled={loading || !name.trim()}
      >
        {loading ? 'Adding...' : 'Add Player'}
      </button>
    </form>
  );
}

export default AddPlayerForm;
